import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useRouter } from 'next/router';

import Throbber from '@r1-frontend/ui-react/components/loaders/Throbber';
import ArrowLeft from '@r1-frontend/ui-react/components/svg/arrows/ArrowLeft';

import { FAQArticlePreview } from '~/src/features/faq/components/FAQArticlePreview';
import { FAQTopicList } from '~/src/features/faq/components/FAQTopicsList';
import { setFAQRedirectLoading } from '~/src/features/faq/store/actionCreators';
import { selectActiveCategoryArticles, selectServiceHelpFAQIsRedirected } from '~/src/features/faq/store/selectors';

import * as ST from './styled';

const Index = () => {
    const articlesByActiveCategory = useSelector(selectActiveCategoryArticles);
    const isLoading = useSelector(selectServiceHelpFAQIsRedirected);
    const router = useRouter();
    const dispatch = useDispatch();

    return <>
        <ST.Container>
            <ST.ButtonBack
                animation={false}
                bType={'ghost'}
                Icon={<ArrowLeft/>}
                onClick={() => {
                    dispatch(setFAQRedirectLoading(true));
                    router.push('/faq');
                }}
            >
                Назад
            </ST.ButtonBack>
            <ST.Wrap>
                <FAQTopicList/>
                <ST.Articles>
                    {articlesByActiveCategory.map(({ _id, articleTitle, articleSubtitle, alias }) =>
                        <FAQArticlePreview
                            key={_id}
                            articleAlias={alias}
                            articleDescription={articleSubtitle}
                            articleName={articleTitle}
                        />)}
                    {isLoading && <Throbber position={'absolute'}/>}
                </ST.Articles>
            </ST.Wrap>
        </ST.Container>
    </>;
};

export default Index;
